export default {
    styleOverrides: {
        root: {
            // Hide empty MenuItems in DataGrid filter dropdowns
            // Target MenuItems with empty data-value within DataGrid filter menus
            '&.MuiDataGrid-filterMenu .MuiMenuItem-root[data-value=""]': {
                display: 'none !important',
            },
        },
    },
};
